import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeploymentService } from 'src/app/core/services/deployment.service';

@Component({
selector: 'app-job-info-download',
templateUrl: './job-info-download.component.html',
styleUrls: ['./job-info-download.component.scss']
})
export class JobInfoDownloadComponent implements OnInit {

constructor(
	public dialogRef: MatDialogRef<JobInfoDownloadComponent>,
	@Inject(MAT_DIALOG_DATA) public data: { depName: string },
	private deploymentService: DeploymentService,
	private snackbar: MatSnackBar,
	private spiner: NgxSpinnerService,
	) { }

	depName = this.data.depName;

	templates: JobInfoDownloadTemplateDTO[] = [];
	isShowingSaveTemplate = false;
	isEditingTemplate = false;
	newTemplateName = '';
	selectedTemplate: JobInfoDownloadTemplateDTO | null = null;
	isAllSelected: boolean = true;
	fieldsObj : { name: string, isChecked: boolean, isMandatory: boolean }[] = [
			// { name : "JobNumber", isChecked: true, isMandatory: true },
			// { name : "JobName", isChecked: true, isMandatory: true },
			// { name : "GlobalState", isChecked: true, isMandatory: true },
			// { name : "JobStage", isChecked: true, isMandatory: true },
			// { name : "JobStageStatus", isChecked: true, isMandatory: true },
			{ name : "UserProfileId", isChecked: true, isMandatory: false },
			{ name : "ProfileId", isChecked: true, isMandatory: false },
			{ name : "JobCores", isChecked: true, isMandatory: false },
			{ name : "JobCoresMin", isChecked: true, isMandatory: false },
			{ name : "CreateTime", isChecked: true, isMandatory: false },
			{ name : "LastSubmitTime", isChecked: true, isMandatory: false },
			{ name : "EndTime", isChecked: true, isMandatory: false },
			{ name : "JobTotalExecuteTime", isChecked: true, isMandatory: false },
			{ name : "JobTotalWaitTime", isChecked: true, isMandatory: false },
			{ name : "JobLifeSpan", isChecked: true, isMandatory: false },
			{ name : "TotalJobCoreHours", isChecked: true, isMandatory: false },
			// { name : "JobStatusReason", isChecked: true, isMandatory: false },
			// { name : "JobDescription", isChecked: true, isMandatory: false },
			// { name : "JobStageCommand", isChecked: true, isMandatory: false },
			{ name : "JobInputFiles", isChecked: true, isMandatory: false },
			{ name : "JobWorkingDirectory", isChecked: true, isMandatory: false },
			{ name : "JobOutFileName", isChecked: true, isMandatory: false },
			{ name : "JobOutLocation", isChecked: true, isMandatory: false },
			{ name : "JobPriority", isChecked: true, isMandatory: false },
			{ name : "JobApplication", isChecked: true, isMandatory: false },
			{ name : "AutoShut", isChecked: true, isMandatory: false },
			// { name : "JobInformation", isChecked: true, isMandatory: false },
			{ name : "JobAppVersion", isChecked: true, isMandatory: false },
      { name: "JobAllocatedNodes", isChecked: true, isMandatory: false },
      { name: "Partition", isChecked: true, isMandatory: false },
			// { name : "OutputDownloadState", isChecked: true, isMandatory: false },
			// { name : "JobOutputDataSize", isChecked: true, isMandatory: false },
			// { name : "DownloadedDataSize", isChecked: true, isMandatory: false },
		{ name: "JobTag", isChecked: true, isMandatory: false },
		{ name: "CustomTag", isChecked: true, isMandatory: false }
	]
	toShowFields= ["JobNumber", "JobName", "GlobalState", "JobStage", "JobStageStatus"]

	ngOnInit(): void {
		this.loadTemplates();
	}

	onSubmit(){
		this.fieldsObj.forEach(field => {
			if(field.isChecked == true){
				this.toShowFields.push(field.name);
			}
		});
		this.dialogRef.close(this.toShowFields)
	}

	onCancel(){
		this.dialogRef.close(false);
	}

	selectAll(){
		this.isAllSelected = !this.isAllSelected;
		if(!this.isAllSelected) {
			this.fieldsObj.forEach(field => {
				if(!field.isMandatory){
					field.isChecked = false
				}
			});
		} else {
			this.fieldsObj.forEach(field => {
				field.isChecked = true
			});
		}
	}

	isAllSelectedCheck(){
		let idx = this.fieldsObj.findIndex(field => field.isChecked == false);
		if(idx == -1){
			this.isAllSelected = true;
			return true
		}
		this.isAllSelected = false;
		return false;
	}

	showSaveTemplate(template?: JobInfoDownloadTemplateDTO) {
		if (template) {
			this.isEditingTemplate = true;
			this.selectedTemplate = template;
			this.newTemplateName = template.name;
		} else {
			this.isEditingTemplate = false;
			this.selectedTemplate = null;
			this.newTemplateName = '';
		}
		this.isShowingSaveTemplate = true;
	}

	saveTemplate() {
		const trimmedName = this.newTemplateName?.trim();
		if (!trimmedName) {
			return;
		}
		
		if(this.templates && this.templates?.length > 0){
			const isDuplicate = this.templates?.some(t => 
				t?.name?.toLowerCase() === trimmedName.toLowerCase()
			);
			
			if (isDuplicate) {
				this.snackbar.open('A template with this name already exists. Please choose a different name.', "Ok",
					{ duration: 3000}
				)
				return;
			}
		}
		
		const templateData = {
			name: trimmedName,
			fields: JSON.stringify(this.fieldsObj?.map(field => ({ ...field })))
		};
		this.spiner.show();
		this.deploymentService.adddeleteJobInfoDownloadTemplate(this.depName, "create", templateData)
			.subscribe({
				next: () => {
					this.spiner.hide();
					this.loadTemplates();
					this.resetTemplateForm();
				},
				error: () => {
					this.spiner.hide();
				}
		})
	}
		
	deleteTemplate(template: JobInfoDownloadTemplateDTO) {
		const templateData = {
			name: template?.name,
			fields: JSON.stringify(template?.fields?.map(field => ({ ...field })))
		};
		this.spiner.show();
		this.deploymentService.adddeleteJobInfoDownloadTemplate(this.depName, "delete", templateData)
			.subscribe({
				next: () => {
					this.spiner.hide();
					this.loadTemplates();
					this.resetTemplateForm();
				},
				error: () => {
					this.spiner.hide();
				}
		})
	}

	loadTemplate(template: any) {
		this.fieldsObj = template?.fields?.map((field: any) => ({ ...field }));
	}

	resetTemplateForm() {
		this.isShowingSaveTemplate = false;
		this.isEditingTemplate = false;
		this.selectedTemplate = null;
		this.newTemplateName = '';
	}

	loadTemplates() {
		this.spiner.show();
		this.deploymentService.getJobinfoDownloadTemplates(this.depName).subscribe({
			next:(data) => {
				this.spiner.hide();
				this.templates = JSON.parse(JSON.stringify(data));
			},
			error:(error)=> {
				this.spiner.hide();
			}
		})
	}
}

interface JobInfoDownloadTemplateDTO {
	name: string;
	fields: any[];
}
